// Utils & misc
import cn from '../../../utils/cn';

// Style
import style from './GridMasonry.module.css';

/**
 * GridMasonry component
 * A component that creates a masonry grid layout.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - The child elements to be displayed in the masonry grid
 * @param {2 | 3} [props.maxColumns=3] - Maximum number of columns on large screens
 * @returns {JSX.Element} The GridMasonry component
 */
function GridMasonry({ children, maxColumns = 3 }) {
  return (
    <div className={cn([style['grid-masonry'], maxColumns === 2 && style['grid-masonry-max-2']])}>
      {children}
    </div>
  );
}

export default GridMasonry;
